<div class="modal-body mb-0 pb-3">
  <h4 class="text-center" i18n>You have an order in progress</h4>
  <p class="text-center mb-0 pb-0" i18n>Do you want to keep it or clear chat history and start a new order?</p>
</div>
<div class="modal-footer text-center mt-0 pt-0">
  <span class="d-inline-block mx-auto">
    <button type="button" class="btn btn-primary" (click)="keep()" i18n>Keep current order</button>
    &nbsp;
    <button type="button" class="btn btn-primary" (click)="empty()" i18n>Start new order</button>
  </span>
</div>
